import { Badge } from '../../../components/Badge';
import type { BadgeSize } from '../../../components/Badge/Badge';
import { DOCUMENT_TYPE_META, STATUS_META, UNDERWRITING_STATUS_META } from '../constants';
import type { DocumentType, PolicyStatus, RiskTier, UnderwritingStatus } from '../types';

export const PolicyStatusBadge: React.FC<{ status: PolicyStatus; size?: BadgeSize }> = ({
  status,
  size = 'sm',
}) => {
  const meta = STATUS_META[status];
  return (
    <Badge variant={meta.badge} size={size}>
      {meta.label}
    </Badge>
  );
};

export const UnderwritingStatusBadge: React.FC<{ status: UnderwritingStatus; size?: BadgeSize }> = ({
  status,
  size = 'sm',
}) => {
  const meta = UNDERWRITING_STATUS_META[status];
  return (
    <Badge variant={meta.badge} size={size}>
      {meta.label}
    </Badge>
  );
};

export const DocumentTypeBadge: React.FC<{ type: DocumentType; size?: BadgeSize }> = ({
  type,
  size = 'sm',
}) => {
  const meta = DOCUMENT_TYPE_META[type];
  return (
    <Badge variant={meta.badge} size={size}>
      {meta.label}
    </Badge>
  );
};

const RISK_TIER_META: Record<RiskTier, { label: string; variant: 'success' | 'info' | 'warning' }> = {
  preferred: { label: 'Preferred', variant: 'success' },
  standard: { label: 'Standard', variant: 'info' },
  substandard: { label: 'Substandard', variant: 'warning' },
};

export const RiskTierBadge: React.FC<{ tier: RiskTier; size?: BadgeSize }> = ({ tier, size = 'sm' }) => {
  const meta = RISK_TIER_META[tier];
  return (
    <Badge variant={meta.variant} size={size}>
      {meta.label}
    </Badge>
  );
};

const PRIORITY_META: Record<'low' | 'medium' | 'high', { label: string; variant: 'secondary' | 'info' | 'error' }> = {
  low: { label: 'Low', variant: 'secondary' },
  medium: { label: 'Medium', variant: 'info' },
  high: { label: 'High', variant: 'error' },
};

export const PriorityBadge: React.FC<{ priority: 'low' | 'medium' | 'high'; size?: BadgeSize }> = ({
  priority,
  size = 'sm',
}) => {
  const meta = PRIORITY_META[priority];
  return (
    <Badge variant={meta.variant} size={size}>
      {meta.label} Priority
    </Badge>
  );
};
